var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25C6.61547 2.25 2.25 6.61547 2.25 12C2.25 17.3845 6.61547 21.75 12 21.75C17.3845 21.75 21.75 17.3845 21.75 12C21.75 6.61547 17.3845 2.25 12 2.25Z",
    stroke: "#666969",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 2.25C9.27788 2.25 6.71851 6.61547 6.71851 12C6.71851 17.3845 9.27788 21.75 11.9999 21.75C14.7219 21.75 17.2813 17.3845 17.2813 12C17.2813 6.61547 14.7219 2.25 11.9999 2.25Z",
    stroke: "#666969",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5001 18.5001C16.7076 17.2274 14.451 16.4685 11.9999 16.4685C9.54882 16.4685 7.29226 17.2274 5.49976 18.5001M5.49976 5.49976C7.29226 6.77241 9.54882 7.53132 11.9999 7.53132C14.451 7.53132 16.7076 6.77241 18.5001 5.49976H5.49976Z",
    stroke: "#666969",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 12H2.25M12 2.25V21.75V2.25Z",
    stroke: "#666969",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.3886790d6a733d1e64d23915ae4e1c99.svg";
export { ForwardRef as ReactComponent };